import { Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import { appIcons } from "../../assets";
import { t } from "i18next";

const DynamicTabsDrawer = ({
  primaryHeading,
  tabs,
  activeTab,
  handleChangeTab,
  showBackBtn,
  handleBack,
}) => {
  return (
    <Paper sx={{ borderRadius: "6px", p: 2, height: "100%" }}>
      <Stack direction={"row"} alignItems={"center"} gap={showBackBtn ? 1 : 0}>
        {showBackBtn && (
          <img
            src={appIcons.purpleBackArrowIcon}
            width={30}
            height={30}
            onClick={handleBack}
            style={{
              cursor: "pointer",
            }}
          />
        )}
        <Typography
          variant="h1"
          fontSize={"1.1rem"}
          // textAlign={"center"}
          fontWeight={600}
        >
          {primaryHeading}
        </Typography>
      </Stack>
      <Stack mt={2} gap={"2px"}>
        {tabs.map((tab) => (
          <Box
            key={tab.value}
            p={1}
            sx={{ cursor: "pointer" }}
            borderRadius={1}
            bgcolor={activeTab === tab.value ? "primary.light" : null}
            onClick={() => handleChangeTab(tab.value)}
          >
            <Typography
              variant="body1"
              fontSize={"0.875rem"}
              textTransform={"capitalize"}
            >
              {t(tab.label)}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};

export default DynamicTabsDrawer;
